import { Time, Day, HoursOfOperation } from 'components/types/LocationTypes';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

type LocationHoursProps = {
	hours: string;
};

const LocationHours = (props: LocationHoursProps): JSX.Element => {
	const { hours } = props;
	const [hoursData, setHoursData] = useState(Array<Day>());
	const [currentDay, setCurrentDay] = useState('');
	const [currentTime, setCurrentTime] = useState('');
	const jsonHours: Array<HoursOfOperation> = JSON.parse(hours);
	const times = Array<Time>();

	jsonHours.forEach((time) => {
		let newTime = {} as Time;
		newTime.DayOfWeek = time.openDay;
		newTime.OpenTime = time.openTime;
		newTime.CloseTime = time.closeTime;
		newTime.Open24Hours = parseInt(time.closeTime) - parseInt(time.openTime) == 24;
		times.push(newTime);
	});

	const formatTime = (time: string) => {
		const [hours, minutes] = time.split(':');
		return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
	};

	const parseHoursData = () => {
		const hours: Array<Day> = times.map((time) => ({
			id: time.DayOfWeek.toLowerCase(),
			open: time.Open24Hours ? '00:00' : formatTime(time.OpenTime),
			close: time.Open24Hours ? '24:00' : formatTime(time.CloseTime),
			open24Hours: time.Open24Hours,
		}));
		return hours;
	};

	const getCurrentTime = () => {
		const now = new Date();
		return now.toTimeString().slice(0, 5);
	};

	const getCurrentDay = () => {
		const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
		const now = new Date();
		return days[now.getDay()];
	};

	const updateTimeAndDay = () => {
		setCurrentTime(getCurrentTime());
		setCurrentDay(getCurrentDay());
		updateStatus();
	};

	const updateStatus = () => {
		hoursData.forEach((day) => {
			const dayElement = document.getElementById(day.id);
			const statusElement = dayElement?.querySelector('.status');

			if (day.id === currentDay) {
				const openTime = day.open;
				const closeTime = day.close;

				dayElement?.classList.remove('open', 'closed', 'opening-soon', 'closing-soon');

				if (day.open24Hours) {
					dayElement?.classList.add('open');
					statusElement && (statusElement.textContent = 'Open 24 Hours');
				} else if (
					currentTime >= openTime &&
					currentTime < closeTime &&
					new Date(`1970-01-01T${closeTime}:00Z`).getTime() -
						new Date(`1970-01-01T${currentTime}:00Z`).getTime() >
						1800000
				) {
					dayElement?.classList.add('open');
					statusElement && (statusElement.textContent = 'Open Now');
				} else if (
					currentTime < openTime &&
					new Date(`1970-01-01T${openTime}:00Z`).getTime() -
						new Date(`1970-01-01T${currentTime}:00Z`).getTime() <=
						1800000
				) {
					dayElement?.classList.add('opening-soon');
					statusElement && (statusElement.textContent = 'Opening Soon');
				} else if (
					currentTime >= openTime &&
					new Date(`1970-01-01T${closeTime}:00Z`).getTime() -
						new Date(`1970-01-01T${currentTime}:00Z`).getTime() <=
						1800000 &&
					new Date(`1970-01-01T${closeTime}:00Z`).getTime() -
						new Date(`1970-01-01T${currentTime}:00Z`).getTime() >
						0
				) {
					dayElement?.classList.add('closing-soon');
					statusElement && (statusElement.textContent = 'Closing Soon');
				} else {
					dayElement?.classList.add('closed');
					statusElement && (statusElement.textContent = 'Closed');
				}
			}
		});
	};

	useEffect(() => {
		setHoursData(parseHoursData());
		updateTimeAndDay();
		setInterval(updateStatus.bind(this), 60000);
	}, [currentDay]);

	return (
		<div className="hours-container" data-hours={JSON.stringify(times)}>
			<h2 className="osf-inner-h2">Hours</h2>
			<ul className="hours-list">
				{times.map((time, index) => (
					<li
						className="hours-item osf-intro-copy"
						id={time.DayOfWeek.toLowerCase()}
						key={`time-${index}`}
					>
						<span className="day">{time.DayOfWeek}</span>
						<span className="time">
							{time.Open24Hours
								? 'Open 24 Hours'
								: moment.utc(parseInt(times[index].OpenTime), 'h:mm').format('h:mm A') +
								  ' - ' +
								  moment.utc(parseInt(times[index].CloseTime), 'h:mm').format('h:mm A')}
						</span>
						<span className="status"></span>
					</li>
				))}
			</ul>
			<p>Hours may vary during the holidays. Please call to confirm.</p>
		</div>
	);
};

export default LocationHours;
